import React from 'react';
import { useTranslation } from 'react-i18next';
import { Crown, Lock } from 'lucide-react';

/** Ίδιο κλείδωμα Premium με το παλιό ταμπλό: οι αναφορές και η Εξαγωγή θέλουν analytics_tier = premium. */
export const PremiumLock: React.FC = () => {
  const { t } = useTranslation(['analytics', 'common']);
  return (
    <div className="flex flex-col items-center justify-center py-20" data-testid="premium-lock">
      <div className="relative mb-6">
        <div className="w-20 h-20 rounded-2xl bg-gradient-to-br from-amber-500/20 to-yellow-500/20 border border-amber-500/30 flex items-center justify-center">
          <Crown className="w-10 h-10 text-amber-700 dark:text-amber-400" aria-hidden="true" />
        </div>
        <div className="absolute -bottom-1 -right-1 w-7 h-7 rounded-full bg-surface-1 border-2 border-amber-500/50 flex items-center justify-center">
          <Lock className="w-3.5 h-3.5 text-amber-700 dark:text-amber-400" aria-hidden="true" />
        </div>
      </div>
      <h2 className="text-xl font-bold text-t1 mb-2">{t('analytics:storeAnalytics.premiumTitle')}</h2>
      <p className="text-t3 text-sm text-center max-w-md mb-4">{t('analytics:storeAnalytics.premiumDesc')}</p>
      <div className="flex items-center gap-2 px-4 py-2 bg-amber-500/10 border border-amber-500/30 rounded-xl text-amber-700 dark:text-amber-400 text-sm">
        <Crown className="w-4 h-4" aria-hidden="true" />
        <span>{t('analytics:storeAnalytics.premiumRequired2')}</span>
      </div>
    </div>
  );
};

export default PremiumLock;
